(() => {
  if (window.fnCartConversionReady) return;
  window.fnCartConversionReady = true;
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let resetWrite = Promise.resolve();
  function clearCheckoutAgreement() {
    resetWrite = resetWrite.catch(() => {}).then(async () => {
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: {'Content-Type': 'application/json'},
        signal: AbortSignal.timeout(15000),
        body: JSON.stringify({attributes: {
          '_checkmate_terms_accepted': 'false',
          '_checkmate_required_ok': 'false',
          'Shipping policy agreement': '',
          'Shipping policy agreed at': '',
          'Shipping policy URL': ''
        }})
      });
      if (!response.ok) throw new Error('Agreement reset failed');
    });
    resetWrite.catch(() => {});
    return resetWrite;
  }
  if (document.querySelector('[data-fn-consent] .checkmate-terms__checkbox')) clearCheckoutAgreement();
  document.addEventListener('change', event => {
    if (event.target.matches('[data-fn-consent] input[type="checkbox"]') && !event.target.checked) clearCheckoutAgreement();
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted && performance.getEntriesByType('navigation')[0]?.type !== 'back_forward') return;
    window.setTimeout(() => {
    busy = false;
    clearCheckoutAgreement();
    document.querySelectorAll('[data-fn-consent]').forEach(consent => {
      consent.querySelector('[data-fn-agree], .checkmate-terms__checkbox').checked = false;
      consent.querySelector('[data-fn-consent-error]').hidden = true;
      const form = document.getElementById(consent.dataset.form);
      form?.querySelector('[data-fn-checkout]')?.remove();
      document.querySelectorAll('button[data-fn-consent-busy]').forEach(button => {
        if (button.form === form) {
          button.disabled = false;
          delete button.dataset.fnConsentBusy;
        }
      });
    });
    }, 0);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('button[name="checkout"]');
    if (!button || !button.form) return;
    const consent = [...document.querySelectorAll('[data-fn-consent]')].find(el => el.dataset.form === button.form.id);
    if (!consent?.querySelector('.checkmate-terms__checkbox')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    button.form.requestSubmit(button);
  }, true);
  document.addEventListener('submit', async event => {
    const form = event.target;
    const consent = [...document.querySelectorAll('[data-fn-consent]')].find(el => el.dataset.form === form.id);
    if (!consent) return;
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    const checkbox = consent.querySelector('[data-fn-agree], .checkmate-terms__checkbox');
    const error = consent.querySelector('[data-fn-consent-error]');
    error.hidden = true;
    if (!checkbox.checked) {
      error.textContent = consent.dataset.required;
      error.hidden = false;
      checkbox.focus();
      return;
    }
    busy = true;
    submitter.disabled = true;
    submitter.dataset.fnConsentBusy = '';
    try {
      await resetWrite.catch(() => clearCheckoutAgreement());
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json'},
        signal: AbortSignal.timeout(15000),
        body: JSON.stringify({attributes: {
          '_checkmate_terms_accepted': 'true',
          '_checkmate_required_ok': 'true',
          'Shipping policy agreement': consent.dataset.version,
          'Shipping policy agreed at': new Date().toISOString(),
          'Shipping policy URL': consent.querySelector('a').href
        }})
      });
      if (!response.ok) throw new Error();
      const cart = await response.json();
      if (cart.attributes?.['_checkmate_terms_accepted'] !== 'true' ||
          cart.attributes?.['_checkmate_required_ok'] !== 'true' ||
          cart.attributes?.['Shipping policy agreement'] !== consent.dataset.version ||
          !cart.attributes?.['Shipping policy agreed at'] ||
          cart.attributes?.['Shipping policy URL'] !== consent.querySelector('a').href) throw new Error();
      let checkout = form.querySelector('input[data-fn-checkout]');
      if (!checkout) {
        checkout = document.createElement('input');
        checkout.type = 'hidden'; checkout.name = 'checkout'; checkout.value = 'Check out';
        checkout.dataset.fnCheckout = ''; form.append(checkout);
      }
      HTMLFormElement.prototype.submit.call(form);
    } catch {
      error.textContent = consent.dataset.error; error.hidden = false;
      submitter.disabled = false;
      delete submitter.dataset.fnConsentBusy;
      busy = false;
    }
  }, true);
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-fn-cart-add]');
    if (!button || button.disabled) return;
    const card = button.closest('[data-fn-addon]');
    const status = card.querySelector('[role=status]');
    button.disabled = true;
    status.textContent = '';
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: [{id: button.dataset.fnCartAdd, quantity: 1}]})
      });
      if (!response.ok) throw new Error();
      status.textContent = button.dataset.added;
      window.location.reload();
    } catch {
      status.textContent = button.dataset.error;
      button.disabled = false;
    }
  });
})();
